<script lang="ts" setup>
import constants from '~/constants'
import Page from '~/enums/page'
import type { BreadcrumbsItem } from '~/types/breadcrumbs'

const breadcrumbsItems: BreadcrumbsItem[] = [{ name: 'Главная', path: Page.Main }]
const title = 'Возврат товаров надлежащего качества'

useHead({
  title: `${title} — iTAB`,
  meta: [{
    name: 'description',
    content: 'Если вас не устроил товар с нашего сайта, вы можете оформить возврат.'
  }]
})
</script>

<template>
  <section>
    <div class="container">
      <Breadcrumbs :current="title" :items="breadcrumbsItems" />

      <div class="content-wrapper">
        <h1>{{ title }}</h1>

        <p>Мы&nbsp;предъявляем высокие требования к&nbsp;качеству и&nbsp;безопасности товаров. Мы&nbsp;ценим ваше доверие и&nbsp;делаем всё, чтобы вы&nbsp;получали удовольствие от&nbsp;покупок, именно поэтому возврат в&nbsp;iTAB&nbsp;— это просто.</p>

        <p>Если по&nbsp;каким-то причинам продукт вам не&nbsp;подошёл, вы&nbsp;можете отказаться от&nbsp;него в&nbsp;течение&nbsp;3 (трёх) календарных дней после получения.</p>

        <h2>Условия возврата</h2>

        <p>Вернуть товар можно при условии, что он&nbsp;не&nbsp;был в&nbsp;употреблении, сохранены его товарный вид и&nbsp;потребительские свойства, пломбы, фабричные ярлыки, упаковка, а&nbsp;также кассовый чек. Вы&nbsp;можете обменять купленный товар на&nbsp;такой&nbsp;же, либо на&nbsp;другой с&nbsp;идентичной стоимостью и&nbsp;выше. Во&nbsp;втором случае вы&nbsp;оплачиваете разницу в&nbsp;стоимости товаров.</p>

        <p>Чтобы произвести обмен, необходимо отправить купленный товар в&nbsp;течение не&nbsp;более&nbsp;3 (трёх) календарных дней с&nbsp;момента получения за&nbsp;свой счёт курьерской доставкой по&nbsp;адресу: 117463, г. Москва, ул. Голубинская, д. 4А, стр.&nbsp;2, офис 202 (получатель: Александр Чайко, контактный телефон: <a class="whitespace-nowrap" :href="constants.phoneNumbers.mainWarehouse.href">{{ constants.phoneNumbers.mainWarehouse.formattedText }}</a>) и&nbsp;оплатить доставку нового товара.</p>

        <p>Если вы&nbsp;не&nbsp;желаете заменить один товар другим, то&nbsp;получите деньги обратно (за&nbsp;исключением расходов на&nbsp;доставку) в&nbsp;срок от&nbsp;3 (трёх) рабочих дней (зависит от&nbsp;банка) с&nbsp;момента поступления возвращённого товара на&nbsp;наш склад.</p>

        <p>Мы&nbsp;оставляем за&nbsp;собой право на&nbsp;отказ от&nbsp;возврата в&nbsp;случае, если товар был в&nbsp;употреблении, не&nbsp;сохранены его товарный вид и&nbsp;потребительские свойства, пломбы, фабричные ярлыки, упаковка, а&nbsp;также отсутствует кассовый чек.</p>

        <p>Если товар был куплен во&nbsp;время промоакции или со&nbsp;скидкой, возврат осуществляется вместе с&nbsp;подарком и&nbsp;по&nbsp;той стоимости, которая была фактически вами уплачена на&nbsp;момент покупки товара.</p>

        <h2>Возврат товаров ненадлежащего качества</h2>

        <p>Если товар значительно пострадал (повреждение не&nbsp;позволяет в&nbsp;полном объеме использовать его: напр., разбился, протёк, сломался и&nbsp;т.&nbsp;п.) при перевозке, средства за&nbsp;товар и&nbsp;доставку возвращаются в&nbsp;полном объёме в&nbsp;срок от&nbsp;3 (трёх) рабочих дней с&nbsp;момента получения посылки с&nbsp;повреждённым товаром на&nbsp;наш склад. Факт повреждения товара при перевозке обязательно должен быть зафиксирован вами в&nbsp;акте во&nbsp;время получения посылки, которую необходимо вскрыть в&nbsp;присутствии сотрудников логистической компании.</p>

        <h2>Несвоевременный забор/получение посылки</h2>

        <p>Если вы&nbsp;не&nbsp;успели забрать товар из&nbsp;ПВЗ (пункт выдачи заказов) или получить его у&nbsp;курьера, и&nbsp;посылка вернулась к&nbsp;нам обратно, средства за&nbsp;товар полностью возвращаются в&nbsp;срок от&nbsp;3 (трёх) рабочих дней с&nbsp;момента прибытия посылки на&nbsp;наш склад без учёта фактически осуществлённой доставки.</p>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@use 'assets/css/content';
</style>
